<template>
  <div class="home-container">
    <!-- 1. 数据总览组（保留原有） -->
    <div class="card-group">
      <h3 class="group-title">数据总览</h3>

      <div class="stat-card" @click="toFilteredList('lost', 'true')">
        <div class="card-title">同门店流失</div>
        <div class="card-value">{{ countMap.lost_true || 0 }}</div>
        <div class="card-desc">点击跟进</div>
      </div>
      <div class="stat-card" @click="toFilteredList('lost', 'false')">
        <div class="card-title">全部数据</div>
        <div class="card-value">{{ countMap.lost_false || 0 }}</div>
        <div class="card-desc">点击跟进</div>
      </div>
      <div class="stat-card" @click="toFilteredList('signed', 'true')">
        <div class="card-title">已签约数据</div>
        <div class="card-value">{{ countMap.signed_true || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
      <div class="stat-card" @click="toFilteredList('time', 'month_arrival')">
        <div class="card-title">本月到店</div>
        <div class="card-value">{{ countMap.time_month_arrival || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
      <!-- 昨天到店卡片 -->
      <div class="stat-card" @click="toFilteredList('time', 'yesterday')">
        <div class="card-title">昨天到店</div>
        <div class="card-value">{{ countMap.time_yesterday || 0 }} <span class="text-xs text-gray-400"></span></div>
        <div class="card-desc">点击查看</div>
      </div>

      <!-- 今天到店卡片 -->
      <div class="stat-card" @click="toFilteredList('time', 'today')">
        <div class="card-title">今天到店</div>
        <div class="card-value">{{ countMap.time_today || 0 }} <span class="text-xs text-gray-400"></span></div>
        <div class="card-desc">点击查看</div>
      </div>
    </div>

    <!-- 2. 到店类型组（保留原有） -->
    <div class="card-group">
      <h3 class="group-title">到店类型</h3>
      <div
        v-for="item in leixingList"
        :key="item.id"
        class="stat-card"
        @click="toFilteredList('leixing', item.id)"
      >
        <div class="card-title">{{ item.name }}</div>
        <div class="card-value">{{ countMap[`leixing_${item.id}`] || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
    </div>

    <!-- 3. 客户意向组（保留原有） -->
    <div class="card-group">
      <h3 class="group-title">客户意向</h3>
      <div class="stat-card" @click="toFilteredList('yixiangdu', 'A')">
        <div class="card-title">高意向</div>
        <div class="card-value">{{ countMap.yixiangdu_A || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
      <div class="stat-card" @click="toFilteredList('yixiangdu', 'B')">
        <div class="card-title">中意向</div>
        <div class="card-value">{{ countMap.yixiangdu_B || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
      <div class="stat-card" @click="toFilteredList('yixiangdu', 'C')">
        <div class="card-title">低意向</div>
        <div class="card-value">{{ countMap.yixiangdu_C || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
    </div>

    <!-- 4. 跟进时间组（扩展原有） -->
    <div class="card-group">
      <h3 class="group-title">跟进时间</h3>
      <div class="stat-card" @click="toFilteredList('time', 'within7')">
        <div class="card-title">7天内更新</div>
        <div class="card-value">{{ countMap.time_within7 || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
      <div class="stat-card" @click="toFilteredList('time', 'over7')">
        <div class="card-title">超7天未更新</div>
        <div class="card-value">{{ countMap.time_over7 || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
      <div class="stat-card" @click="toFilteredList('time', 'over15')">
        <div class="card-title">超15天未更新</div>
        <div class="card-value">{{ countMap.time_over15 || 0 }}</div>
        <div class="card-desc">点击查看</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { get } from "@/util/request";

export default {
  name: "Home",
  setup() {
    const router = useRouter();
    const leixingList = ref([]);
    const countMap = ref({});
    const totalCount = ref(0);
    const dateRange = ref([]); // 日期范围筛选

    // 核心：获取中国本地时区的「今天」和「昨天」（格式：YYYY-MM-DD）
    const getToday = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份0-11，补0
      const day = String(today.getDate()).padStart(2, '0'); // 日期补0
      return `${year}-${month}-${day}`; // 例如：2025-11-06（中国本地时间）
    };

    const getYesterday = () => {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1); // 本地时间减1天
      const year = yesterday.getFullYear();
      const month = String(yesterday.getMonth() + 1).padStart(2, '0');
      const day = String(yesterday.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`; // 例如：2025-11-05（中国本地时间）
    };

    // 1. 获取到店类型列表（保留原有）
    const fetchLeixingList = async () => {
      const res = await get("/api/leixing/");
      if (res.data.code === 200) {
        leixingList.value = res.data.data || [];
      }
    };

    // 2. 批量获取所有统计数据（核心修改：传递前端本地日期给后端）
    const fetchBatchStats = async () => {
      await fetchLeixingList();
      // 构建参数：新增 today_date 和 yesterday_date（前端中国时区日期）
      const params = {
        stat_type: "batch_count",
        leixing_ids: leixingList.value.map(item => item.id).filter(id => id),
        yixiangdu_list: ["A", "B", "C"],
        follow_time_list: ["within7", "over7", "over15", "gonghai", "month_arrival", "yesterday", "today"],
        lost_list: ["true", "false"],
        signed_list: ["true"],
        today_date: getToday(), // 前端传递的「今天」（中国时区）
        yesterday_date: getYesterday() // 前端传递的「昨天」（中国时区）
      };
      // 发送请求（带日期参数）
      const res = await get("/api/daodian/", params);
      if (res.data.code === 200) {
        countMap.value = res.data.data || {};
        totalCount.value = res.data.total || 0;
      }
    };

    // 3. 点击卡片跳转筛选（保留原有，已处理日期逻辑）
    const toFilteredList = (statType, param) => {
      const query = {};
      switch (statType) {
        case "leixing":
          query.leixingId = param;
          break;
        case "yixiangdu":
          query.yixiangdu = param;
          break;
        case "time":
          if (["within7", "over7", "over15", "gonghai", "month_arrival"].includes(param)) {
            query.followTime = param;
          } else if (param === "today") {
            query.startDate = getToday();
            query.endDate = getToday();
          } else if (param === "yesterday") {
            query.startDate = getYesterday();
            query.endDate = getYesterday();
          }
          break;
        case "lost":
          query.lost = param;
          break;
        case "signed":
          query.signed = param;
          break;
      }
      router.push({ path: "/mobile/list", query });
    };

    // 4. 日期范围筛选（保留原有）
    const handleDateFilter = () => {
      if (!dateRange.value.length) return;
      const query = {
        startDate: dateRange.value[0].toISOString().split("T")[0],
        endDate: dateRange.value[1].toISOString().split("T")[0]
      };
      router.push({ path: "/mobile/list", query });
    };

    // 5. 页面挂载时加载数据
    onMounted(() => {
      fetchBatchStats();
    });

    return {
      leixingList,
      countMap,
      totalCount,
      dateRange,
      toFilteredList,
      handleDateFilter
    };
  },
};
</script>

<style scoped>
.home-container {
  padding: 3px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.card-group {
  margin-bottom: 20px;
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3列布局（按原有样式） */
  gap: 15px; /* 卡片之间的间距 */
}

.group-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 2px;
  padding-bottom: 2px;
  border-bottom: 1px solid #eee;
  grid-column: 1 / -1; /* 标题跨列，占满整行 */
}

.stat-card {
  background: #f9fafc;
  border-radius: 6px;
  padding: 5px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  background: #fff;
}

.card-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.card-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

.card-desc {
  font-size: 12px;
  color: #409eff;
}
</style>